import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const BASE_PASS_URL = `${BASE_URL}api/passes/`;

const PassService = () => ({

    getPass: async (courseId) => {
        const { data } = await axios.get(`${BASE_PASS_URL}${courseId}`);
        return data;
    },

    savePass: async (courseId, passId) => {
        const { data } = await axios.post(`${BASE_PASS_URL}${courseId}?passId=${passId}`);
        return data;
    }
});

export default PassService;